// extracted by mini-css-extract-plugin
module.exports = {"count":"count___3Mp_9","error":"error___g2bFC"};